module.exports = __webpack_public_path__ + "media/open-ended.7a0ca976.webm";